import { chartEmptyValueConstants } from '../chartEmptyValueConstants';
import { chartTableFlatTransformer } from '../chartTableFlatTransformer';

/**
 * Transforms interview data for feedback and duration charts
 * @param response API response data
 * @param feedbackKeys keys for feedback metrics
 * @returns Object containing data for both charts
 */
export const rejectionsReasonsTransformer = ({ response, metadata, args }) => {
  const { chart = [], headers, lookups, table = [] } = response || {};
  const { dt, g1, g2 } = lookups || {}; // Lookup mappings for data transformation

  const data = g1?.length || g2?.length ? table : chart;
  const headerKey = g1?.length ? 'g1' : 'dt';

  const { group_by_1, group_by_2 } = args || {};
  const { tileKey } = metadata || {};

  // Transform raw chart data into a flat structure
  const transformedData = chartTableFlatTransformer({
    headerKey,
    headers,
    data,
    g1,
    g2,
    dt,
    g1Key: group_by_1?.id,
    g2Key: group_by_2?.id,
  });

  const getRejectionData = (categoryName) => {
    return (
      transformedData
        ?.find((item) => item?.g1 === categoryName)
        ?.subRows?.map((r) => ({
          name: r?.g2?.reason || chartEmptyValueConstants?.rejection_reason,
          y: r?.rejections,
          g1: r?.g1,
          g2: r?.g2?.id,
        })) || []
    );
  };

  const categoryMap = {
    we_rejected_them: 'We rejected them',
    they_rejected_us: 'They rejected us',
    others: 'Others',
  };

  // category based on the tile key
  const categoryName = categoryMap[tileKey];

  if (categoryName) {
    const seriesData = getRejectionData(categoryName);
    const categories = seriesData.map((item) => item.name);

    return {
      series: seriesData,
      categories, //For bar/column chart
    };
  }

  return {
    series: [],
    categories: [],
  };
};
